import { Component, OnInit } from '@angular/core';
import { SaleItemService } from '../sale-item.service';
import { SaleService } from '../sale.service';
import { ProductStorageService } from '../../product_storages/product-storage.service';
import { ContractorService } from '../../contractors/contractor.service';
import { ContactService } from '../../contacts/contact.service';
import { OperationService } from '../../operations/operation.service';
import { Message } from 'primeng/primeng';
import { GlobalDataService } from '../../../../services/global-data.service';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/forkJoin';
import { PositionService } from '../../positions/position.service';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-sale-update',
  templateUrl: './sale-update.component.html',
  styleUrls: ['./sale-update.component.css'],
  providers: [
    SaleItemService,
    SaleService,
    OperationService,
    PositionService,
    ContractorService,
    ProductStorageService,
    ContactService
  ]
})
export class SaleUpdateComponent implements OnInit {

  id: any = null;
  contractorId: any = null;
  productsForGrid: any = [];
  salesCartGrid: any = [];
  msgs: Message[] = [];
  contractor: any = [];
  _sale_type: any = [];
  _searchGrid: boolean = false;
  _product_name: any = "";
  _display: boolean = false;
  store_id: any;
  loading: boolean = true;
  loadingQuickRegistr: boolean = false;
  countProductModal: boolean = false;
  productNameModal: string = "";
  productSkuModal: string = "";
  productIdModal: string = "";
  productCountModal: any;
  productItemIdModal: any;
  productIndexModal: any;
  saleTypeModal: any;
  storeIdModal: any;
  total: any;
  sumTotal: any = 0;
  convertedSumTotal: any = 0;

  contractorSaldo: any = 0;

  debt: number = 0;
  paidValue:number = 0;
  paidPurpose: string = "";
  paidPurposeDisabled:boolean = false;
  contractors: any[] = [];
  contacts: any[] = [];
  contact: any = {};

  selectedContractor:any;
  selectedSaleContractor:any;
  isVisibleSaleContrator:boolean = true;

  askDescriptionRedactionModal: boolean = false;
  askDescription:string = "";
  quickRegistrModal: boolean = false;
  messageDisplay: boolean = false;
  deleteIndex: any;
  blocked: boolean = false;
  issueButtonDisabled: boolean = true;

  saleCart: any[] = [];

  saleItemCart: any[] = [];
  saleItemCartLoading: boolean = false;

  saleItemCartServer: any[] = [];
  saleItemCartServerLoading: boolean = false;


  saleItemSearchCartVisible: boolean = false;
  saleItemSearchCartLoading: boolean = false;
  saleItemSearchCart: any[] = [];

  textSku: any;
  textName: any;

  selectedContact: string;
  selectedContactDriver: string;
  selectecDeadlineReplenishment: any;

  selectedSaleItem: string;
  fromType: string;
  title: string;
  deletedSaleItems: any[] = [];
  currencyRateValue: any;

  selectedSaleCartItems:any=[];
  
  constructor(private saleItemService: SaleItemService,
    private saleService: SaleService,
    private operationService: OperationService,
    private positionService: PositionService,
    private productStorageService: ProductStorageService,
    private contractorService: ContractorService,
    private contactService: ContactService,
    private _location: Location,
    private global: GlobalDataService,
    private activatedRoute: ActivatedRoute,
    private router: Router) {

    activatedRoute.params.subscribe(params => {
      this.contractorId = params['contractor_id']
      this.fromType = params['from_type']
      this.id = params['id'];
    });


    if (this.contractorId) {
        this.loadContractors(this.contractorId);
    }



    this.onLoad(this.fromType);
  }

  

  ngOnInit() {

    this.contact = {
      middle_name: "",
      first_name: "",
      genders: [],
      positions: [],
      contractors: []
    }

    this.currencyRateValue = this.global.currencyRate.value;
  }

  loadContractors(contractor_id){

    this.contractorService.getContractorById(contractor_id).subscribe(response => { 
      this.contractor = response['data']; 
      this.contractorSaldo = this.contractor.account && this.contractor.account.saldo;

      this.contractorService.getContractorList().subscribe(response => {
        this.contractors = response['data'].map(function (value: any) {
          return { label: value.name, value: value.id };
        });

        this.selectedSaleContractor = this.contractor.id; 
      })


    })

  }

  loadContacts(callback){
    Observable.forkJoin(
      this.contactService.getContactListByFilter([{ name: 'contractor_id', value: this.contractorId }]),
      this.contactService.getContactListByFilter([{ name: 'contractor_id', value: '62e26f37-f6b0-4452-a4fb-e40fa1cd6b86' }])
    ).subscribe(response=>{
     let contact1 = response[0]['data'].map(function (value: any) {
            return { label: value.full_name, value: value.id };
          });
     let contact2 = response[1]['data'].map(function (value: any) {
       return { label: value.full_name, value: value.id };
     });
          this.contacts = contact1.concat(contact2);
    })
    callback();
  }

  onChangeSaleContractor(){
    this.contractorService.getContractorById(this.selectedSaleContractor).subscribe(response => { 
        this.contractor = response['data']; 
        this.contractorId=this.contractor.id;
        this.contractorSaldo = this.contractor.account && this.contractor.account.saldo;
      });

      this.loadContacts(()=>{});  

  }

  onLoad(type: any) {
    this.saleItemCartLoading = true;
    this.saleItemCart = [];
    if (type == "sale" || type == "sale_update") {

      if(type == "sale_update"){
        this.askDescriptionRedactionModal=true;
        this.paidPurposeDisabled=true;
      }

      this.isVisibleSaleContrator= true;
      this.title = "Редактирование корзины продажи";
      this.saleService.getSaleItemListByIdService(this.id).subscribe(response => {
        this.saleItemCart = response['data'];
        this.saleItemCartLoading = false;
        
        this.loadContacts(()=>{
          this.selectedContactDriver=this.saleItemCart[0].sale.driver_contact_id;
          this.selectedContact=this.saleItemCart[0].sale.with_whom_contact_id;
          this.selectecDeadlineReplenishment=this.saleItemCart[0].sale.deadline_repayment;
          this.paidValue = this.saleItemCart[0].sale.paid;
          this.paidPurpose = this.saleItemCart[0].sale.paid_purpose;
        });

        this.calculateSumTotal();
      });
    } else if (type = "operation") {
      this.isVisibleSaleContrator= false;
      this.title = "Перемещение заявки на продажу";
      this.operationService.getOperationItemsById(this.id).subscribe(response => {
        console.log('this.currencyRateValue');
        console.log(this.currencyRateValue);
        this.store_id =  response['data'][0].store.id;  
        this.saleItemCart = response['data'].map(value => {
          return {
            product: value.product,
            count: value.count,
            price: ((+value.price) * (+this.currencyRateValue)).toFixed(2),
            sale: { currency: { short_name: 'TJS' } },
            total: ((+value.total) * (+this.currencyRateValue)).toFixed(2),
            store: value.store
          }
        });
        console.log(this.saleItemCart);
        this.saleItemCartLoading = false;
        this.loadContacts(()=>{});
        this.calculateSumTotal();
      })
    }
  }

  onEditComplete(data){
    let index = data.index;
    this.saleItemCart[index].count = data.count;
    this.saleItemCart[index].total = (data.count* this.saleItemCart[index].price).toFixed(2);
    this.calculateSumTotal();
  }

  onChangePaid(data) {
    this.debt = (+this.sumTotal) - (+data.value);
    if (this.debt < 0) {
      this.debt = 0;
    }
    this.debt = (+this.debt.toFixed(2));
  }

  delete(index: any) {
    this.messageDisplay = true;
    this.deleteIndex = index;
  }

  OnAgreeDelete() {
    console.log(this.deleteIndex);
    this.deletedSaleItems.push(this.saleItemCart[this.deleteIndex].id);
    console.log(this.deletedSaleItems);
    this.saleItemCart.splice(this.deleteIndex, 1);
    this.deleteIndex = null;
    this.messageDisplay = false;
    this.calculateSumTotal();
    // this.save();
  }

  OnDegreeDelete() {
    this.messageDisplay = false;
  }

  save() {
    // console.log(this.saleItemCart);
    // this.saleItemCartLoading = true;

    // if (this.saleCart[this.id]) {
    //   this.saleCart[this.id].sum_total = (+this.convertedSumTotal).toFixed(2);
    //   this.saleCart[this.id]['items'] = this.saleItemCart;
    // }
    // localStorage.setItem('sales', JSON.stringify(this.saleCart));
    // this.saleItemCartLoading = false;
  }

  saveOnlySaveCart() {
    localStorage.setItem('sales', JSON.stringify(this.saleCart));
  }

  update(data) {
    // this.saleItemCart[this.productIndexModal].count = data.value.count;
    // this.saleItemCart[this.productIndexModal].total = (data.value.count * this.saleItemCart[this.productIndexModal].price).toFixed(2);
    // // this.saleItemCart[this.productIndexModal].total_converted_retail_price = (data.value.count * this.saleItemCart[this.productIndexModal].converted_retail_price).toFixed(2);
    // this.countProductModal = false;
    // this.calculateSumTotal();
    // // this.save();
  }
  onAddAllSaleCartItems(){
    console.log("omad");
    console.log(this.selectedSaleCartItems);
    for(let i=0;i<this.selectedSaleCartItems.length;i++){
      this.addCart(this.selectedSaleCartItems[i]);
    }
    this.selectedSaleCartItems=[];
  }


  addCart(data) {
    console.log('data');
    console.log(data);

    let tmpindex;

    for (let item in this.saleItemCart) {
      if (this.saleItemCart[item].product.id == data.product.id) {
        tmpindex = item;
      }
    }

    if (tmpindex) {
      this.saleItemCart[tmpindex].count = (+this.saleItemCart[tmpindex].count) + (+1);
      this.saleItemCart[tmpindex].total = this.saleItemCart[tmpindex].count * data.retail_price;
      this.saleItemCart[tmpindex].total_converted_retail_price = this.saleItemCart[tmpindex].count * data.converted_retail_price;
    } else {
      this.saleItemCart.push({
        sale: { id: this.id, currency: { short_name: "TJS" } },
        product: data.product,
        // retail_price: data.retail_price,
        // converted_retail_price: data.converted_retail_price,
        price: data.converted_retail_price,
        store: data.store,
        count: 1,
        // total: data.retail_price,
        // total_converted_retail_price: data.converted_retail_price,
        total: data.converted_retail_price,
      });
    }


    this.calculateSumTotal()
    // this.save();
    // this.onLoad();
    this.saleItemSearchCart = [];
    this.saleItemSearchCartVisible = false;
    this.textSku = "";
    this.textName = "";
  }

  search(event, attribute) {
    this.saleItemSearchCart = [];
    this.saleItemSearchCartVisible = true;
    this.saleItemSearchCartLoading = true;
    this.productStorageService.getProductStorageByFilter([{ name: attribute, value: event.query }]).subscribe(response => { this.saleItemSearchCart = response['data']; this.saleItemSearchCartLoading = false; })
  }

  onSearchKeyUp(value) {

    switch (value) {
      case 'sku':
        if (this.textSku.length < 1) {
          this.saleItemSearchCartVisible = false;
        }
        break;

      case 'name':
        if (this.textName.length < 1) {
          this.saleItemSearchCartVisible = false;
        }
        break;
    }

  }


  calculateSumTotal() {
    this.saleItemCart = this.saleItemCart.map((value, index) => { value.index = index; return value; });
    this.sumTotal = this.saleItemCart.reduce(function (sum: any, item: any) { return (+sum) + (+item.total); }, 0);
    this.sumTotal = this.sumTotal.toFixed(2);
    this.convertedSumTotal = this.saleItemCart.reduce(function (sum: any, item: any) { return (+sum) + (+item.total_converted_retail_price); }, 0);
    this.convertedSumTotal = this.convertedSumTotal.toFixed(2);
  }

  onRowSelect(event: any) {

    let index = this.saleItemCart.indexOf(this.selectedSaleItem);

    this.productNameModal = event.data.product.name;
    this.productSkuModal = event.data.product.sku;
    // this.productIdModal=event.data.product.id;
    this.productCountModal = event.data.count;
    this.productIndexModal = index;
    // this.storeIdModal=this._store_id;
    // this.productItemIdModal=event.data.id;
    this.saleTypeModal = 1;
    this.countProductModal = true;
  }

  onShowQuickRegistrModal() {
    this.quickRegistrModal = true;
    this.positionService.getPosition().subscribe(response => {
      this.contact.positions = response['data'].map(function (value: any) {
        return { label: value.name, value: value.id };
      });
    })

    this.contact.genders.push({label: "Мужской", value: "0"});
    this.contact.genders.push({label: "Женский", value: "1"});

    this.selectedContractor = this.contractor.id;

    this.contractorService.getContractorList().subscribe(response => {
      this.contact.contractors = response['data'].map(function (value: any) {
        return { label: value.name, value: value.id };
      });
    })

    

  }


  onAddQuickRegistr(form: NgForm) {
    this.loadingQuickRegistr = true;
     form.value['available']=true;
     this.contactService.createContact(form.value).subscribe(response=>{
        
       this.contactService.getContactListByFilter([{ name: 'contractor_id', value: this.contractor.id }]).subscribe(response => {
         this.contacts = response['data'].map(function (value: any) {
           return { label: value.full_name, value: value.id };
         });
         this.loadingQuickRegistr=false;
         this.quickRegistrModal = false;
       })
       this.selectedContactDriver = response['data'].id;  
     
     })
 }

  cancel(): void {
    this.saleService.saleChanging(this.id,false).subscribe();
    this._location.back();
  }

  showModal(): void {
    this.paidValue = this.paidValue || 0;
    this.onChangePaid({value: this.paidValue });
    this._display = true;
  }

  issue(form: NgForm) {

    this.saleService.saleChanging(this.id,false).subscribe();

    this.blocked = true;

    if (this.fromType == "sale" || this.fromType == "sale_update") {

      let items = this.saleItemCart.map(data => {
        return {
          id: data.id,
          sale_id: data.sale.id,
          product_id: data.product.id,
          store_id: data.store.id,
          count: data.count
        }
      });

      let data = {
        old_sale_id: this.saleItemCart[0].sale.id,
        paid_purpose: this.paidPurpose,
        description: this.askDescription,
        store_id: this.saleItemCart[0].store.id,
        contractor_id: this.selectedSaleContractor,
        with_whom_contact_id: this.selectedContact,
        driver_contact_id: this.selectedContactDriver,
        used_bonus: form.value['used_bonus'],
        on_credit: 100,
        items: items,
        deleted_item_ids: this.deletedSaleItems,
        paid: form.value.paid
      };


      if (form.value['deadlineReplenishment']) {
        data['deadline_repayment'] = form.value['deadlineReplenishment'];
      }

      console.log('send_data');
      console.log(data);

      if(this.fromType == "sale_update"){

        this.router.navigate(['/dashboard/sale']);

        this.saleService.issueSale(data).subscribe(response => {
        },(error)=>{
           this.blocked = false;
          this._display = false;
        });

      }else{
        this.saleService.updateSale(data, this.id).subscribe(response => { this.router.navigate(['/dashboard/sale']); },
        (error) => {
          this.blocked = false;
          this._display = false;
        });
      }
    } else if (this.fromType == "operation") {

      let items = this.saleItemCart.map(data => {
        return {
          id: data.id,
          product_id: data.product.id,
          store_id: data.store.id,
          count: data.count
        }
      });
      let data = {
        contractor_id: this.contractorId,
        operation_id: this.id,
        with_whom_contact_id: this.selectedContact,
        driver_contact_id: this.selectedContactDriver,
        used_bonus: form.value['used_bonus'],
        on_credit: 100,
        store_id: this.store_id,
        items: items,
        paid: form.value.paid
      };

      if (form.value['deadlineReplenishment']) {
        data['deadline_repayment'] = form.value['deadlineReplenishment'];
      }

      this.saleService.issueSale(data).subscribe(response => { this.router.navigate(['/dashboard/sale']); },
        (error) => {
          this.blocked = false;
          this._display = false;
        });
    }
  }

  backClicked() {
    this.saleService.saleChanging(this.id,false).subscribe();
    this._location.back();
  }

}



// WEBPACK FOOTER //
// C:/Users/User/Documents/Projects/Ekopen/angular2-store-test/src/app/dashboard/pages/sales/sale-update/sale-update.component.ts